export const parentSymbol = Symbol('parent');
export const modelSymbol = Symbol('model');
export const vpc = Symbol('viewProxyCache');
export const apc = Symbol('actionProxyCache');
export const observed = '__p_observed';
export const modelName = '__p_model';
